import styled from 'styled-components';

import { media } from '../../../utils/mediaQueries';

export const TopBarWrapper = styled.div`
    width: 100%;
    display: flex;
    align-items: center;
    justify-content: space-between;
    gap: 16px;
    height: 100%;
    min-height: 0;
    position: sticky;
    top: 0;
    z-index: 10;
    transition: all 0.3s ease;

    ${media.tablet} {
        gap: 12px;
    }

    ${media.mobile} {
        gap: 8px;
    }
`;

export const LeftNav = styled.div`
    display: flex;
    align-items: center;
    gap: 12px;
    flex: 1;
    min-width: 0; /* Allow flex items to shrink below content size */
    overflow: hidden;

    ${media.tablet} {
        gap: 8px;
    }

    ${media.mobile} {
        gap: 6px;
    }
`;

/* Para strzałek wstecz/dalej po lewej stronie breadcrumbs (tylko desktop —
   na mobile nawigację wstecz zapewnia system/przeglądarka). */
export const NavArrows = styled.div`
    display: flex;
    align-items: center;
    gap: 8px;
    flex-shrink: 0;

    ${media.tabletDown} {
        display: none;
    }
`;

export const NavArrowButton = styled.button`
    display: inline-flex;
    align-items: center;
    justify-content: center;
    width: 34px;
    height: 34px;
    padding: 0;
    border-radius: 10px;
    box-sizing: border-box;
    cursor: pointer;
    flex-shrink: 0;
    background: ${({ theme }) => (theme.mode === 'dark' ? '#1a1f26' : '#ffffff')};
    border: 1px solid ${({ theme }) => (theme.mode === 'dark' ? '#374151' : '#e5e7eb')};
    color: ${({ theme }) => (theme.mode === 'dark' ? '#e5e7eb' : '#374151')};
    transition: background-color 0.15s ease, border-color 0.15s ease, color 0.15s ease, opacity 0.15s ease;

    &:hover:not(:disabled) {
        background: ${({ theme }) => (theme.mode === 'dark' ? '#242a33' : '#f9fafb')};
        border-color: ${({ theme }) => (theme.mode === 'dark' ? '#4b5563' : '#d1d5db')};
        color: ${({ theme }) => (theme.mode === 'dark' ? '#f9fafb' : '#111827')};
    }

    &:active:not(:disabled) {
        transform: scale(0.95);
    }

    &:disabled {
        opacity: 0.35;
        cursor: not-allowed;
        color: ${({ theme }) => (theme.mode === 'dark' ? '#9ca3af' : '#6b7280')};
    }

    &:focus-visible {
        outline: 2px solid #1a4d4d;
        outline-offset: 2px;
    }
`;

export const RightNav = styled.div`
    display: flex;
    align-items: center;
    justify-content: flex-end;
    gap: 10px;
    flex-shrink: 0; /* Prevent right nav from shrinking */

    ${media.tablet} {
        gap: 8px;
    }

    ${media.mobile} {
        gap: 6px;
    }

    /* Ikony (pomoc, koperta, dzwonek) stylujemy w IconCircleButton —
       RightNav nie narzuca już własnych wymiarów potomkom, żeby nie
       nadpisywać okrągłego kształtu przycisków. */

    /* UserMenu trigger — awatar + chevron. Delikatny hover wokół całości. */
    > div[data-tour='profile'] {
        display: flex;
        align-items: center;

        button {
            display: flex;
            align-items: center;
            padding: 3px 4px 3px 3px;
            border-radius: 999px;
            transition: background-color 0.15s ease;

            &:hover {
                background: ${({ theme }) => (theme.mode === 'dark' ? '#242a33' : '#f3f4f6')};
                opacity: 1;
            }
        }
    }
`;

/* Pionowy separator między ikonami powiadomień a awatarem użytkownika.
   role="separator" wyklucza go z reguły w RightNav, która nadaje
   okrągłym ikonom wymiary 32×32. */
export const VerticalDivider = styled.div`
    width: 1px;
    height: 24px;
    flex-shrink: 0;
    background: ${({ theme }) => (theme.mode === 'dark' ? '#374151' : '#e5e7eb')};

    ${media.mobile} {
        height: 20px;
    }
`;

export const MobileNavigationHeadline = styled.div`
    width: auto;
    height: 100%;
    cursor: pointer;
    display: none;
    color: ${({ theme }) => (theme.mode === 'dark' ? '#e5e7eb' : '#374151')};

    ${media.tabletDown} {
        display: flex;
        align-items: center;
        gap: 12px;
    }

    ${media.mobile} {
        gap: 8px;
    }
`;

export const MobileLogo = styled.div`
    display: none;

    ${media.tabletDown} {
        display: flex;
        align-items: center;
        justify-content: center;

        a {
            display: flex;
            align-items: center;
            justify-content: center;
        }

        svg {
            width: 20px;
            height: auto;

            path {
                fill: #374151;
            }
        }
    }

    ${media.mobile} {
        svg {
            width: 18px;
        }
    }
`;

export const NotificationBadge = styled.span`
    position: absolute;
    top: -4px;
    right: -4px;
    min-width: 18px;
    height: 18px;
    display: flex;
    align-items: center;
    justify-content: center;
    background: linear-gradient(135deg, #ef4444, #dc2626);
    color: white;
    font-size: 10px;
    font-weight: 400;
    border-radius: 9999px;
    padding: 0 5px;
    border: 2px solid #ffffff;
    box-shadow: 0 2px 4px rgba(239, 68, 68, 0.3);

    ${media.mobile} {
        min-width: 16px;
        height: 16px;
        font-size: 9px;
        padding: 0 4px;
    }
`;

/**
 * Okrągły przycisk ikony w prawym TopBar (pomoc, koperta, dzwonek):
 * 38×38, białe tło i cienka szara ramka — wszystkie trzy tworzą spójny
 * rząd okręgów, wizualnie sparowany z awatarem obok.
 */
export const IconCircleButton = styled.button`
    position: relative;
    width: 38px;
    height: 38px;
    padding: 0;
    margin: 0;
    display: inline-flex;
    align-items: center;
    justify-content: center;
    border-radius: 100%;
    background: ${({ theme }) => (theme.mode === 'dark' ? '#1a1f26' : '#ffffff')};
    border: 1px solid ${({ theme }) => (theme.mode === 'dark' ? '#374151' : '#e5e7eb')};
    color: ${({ theme }) => (theme.mode === 'dark' ? '#f3f4f6' : '#111827')};
    cursor: pointer;
    transition: background-color 0.15s ease, border-color 0.15s ease, color 0.15s ease;
    appearance: none;
    -webkit-appearance: none;
    box-sizing: border-box;
    flex-shrink: 0;
    /* Bez overflow: hidden — NotificationBadge wystaje poza okrąg
       (top -4px / right -4px); clipping by go uciął. */

    &:hover {
        background: ${({ theme }) => (theme.mode === 'dark' ? '#242a33' : '#f9fafb')};
        border-color: ${({ theme }) => (theme.mode === 'dark' ? '#4b5563' : '#d1d5db')};
    }

    &:active {
        transform: scale(0.95);
    }

    &:focus-visible {
        outline: 2px solid #1a4d4d;
        outline-offset: 2px;
    }

    ${media.tablet} {
        width: 34px;
        height: 34px;
    }

    ${media.mobile} {
        width: 32px;
        height: 32px;

        svg {
            width: 16px;
            height: 16px;
        }
    }
`;

/* Guzik „Zapytaj" — CTA asystenta AI „Stefan" (wzór ElevenLabs). Pill z małym
   avatarem Stefana + etykietą; klik otwiera/zamyka dokowany panel czatu.
   Gdy panel otwarty ($active) — ciemne wypełnienie „ink", żeby było jasne, że
   asystent jest aktywny. */
export const AskAiButton = styled.button<{ $active?: boolean }>`
    display: inline-flex;
    align-items: center;
    gap: 7px;
    height: 38px;
    padding: 0 14px 0 6px;
    border-radius: 999px;
    box-sizing: border-box;
    cursor: pointer;
    flex-shrink: 0;
    background: ${({ $active, theme }) => {
    if ($active) return theme.mode === 'dark' ? '#f3f4f6' : '#111827';
    return theme.mode === 'dark' ? '#1a1f26' : '#ffffff';
  }};
    border: 1px solid ${({ $active, theme }) => {
    if ($active) return theme.mode === 'dark' ? '#f3f4f6' : '#111827';
    return theme.mode === 'dark' ? '#374151' : '#e5e7eb';
  }};
    color: ${({ $active, theme }) => {
    if ($active) return theme.mode === 'dark' ? '#111827' : '#ffffff';
    return theme.mode === 'dark' ? '#f3f4f6' : '#111827';
  }};
    font-size: 13.5px;
    font-weight: 500;
    transition: background-color 0.15s ease, border-color 0.15s ease, color 0.15s ease;

    &:hover {
        background: ${({ $active, theme }) => {
    if ($active) return theme.mode === 'dark' ? '#ffffff' : '#000000';
    return theme.mode === 'dark' ? '#242a33' : '#f9fafb';
  }};
        border-color: ${({ $active, theme }) => {
    if ($active) return theme.mode === 'dark' ? '#ffffff' : '#000000';
    return theme.mode === 'dark' ? '#4b5563' : '#d1d5db';
  }};
    }

    &:active {
        transform: scale(0.97);
    }

    &:focus-visible {
        outline: 2px solid #1a4d4d;
        outline-offset: 2px;
    }

    ${media.tablet} {
        height: 34px;
    }

    ${media.mobile} {
        height: 32px;
        padding: 0 10px 0 5px;
        gap: 5px;
    }
`;

export const AskAiAvatar = styled.img`
    width: 26px;
    height: 26px;
    border-radius: 50%;
    object-fit: cover;
    display: block;
    flex-shrink: 0;
    border: 1.5px solid ${({ theme }) => (theme.mode === 'dark' ? '#0f1419' : '#ffffff')};
    box-shadow: 0 1px 3px rgba(15, 23, 42, 0.18);

    ${media.mobile} {
        width: 22px;
        height: 22px;
    }
`;

export const AskAiLabel = styled.span`
    white-space: nowrap;
    font-weight: 500;

    ${media.mobile} {
        font-size: 12px;
    }
`;

export const TaskBadge = styled.span`
    position: absolute;
    top: 0px;
    right: -2px;
    min-width: 18px;
    height: 18px;
    display: flex;
    align-items: center;
    justify-content: center;
    background: linear-gradient(135deg, #1a4d4d, #0f3333);
    color: white;
    font-size: 10px;
    font-weight: 400;
    border-radius: 6px;
    padding: 0 5px;
    border: 2px solid #ffffff;
    box-shadow: 0 2px 4px rgba(26, 77, 77, 0.3);

    ${media.mobile} {
        min-width: 16px;
        height: 16px;
        font-size: 9px;
        padding: 0 4px;
    }
`;

export const TaskBadgeGreen = styled.span`
    position: absolute;
    top: 0px;
    right: -2px;
    min-width: 18px;
    height: 18px;
    display: flex;
    align-items: center;
    justify-content: center;
    background: linear-gradient(135deg, #10b981, #059669);
    color: white;
    font-size: 10px;
    font-weight: 400;
    border-radius: 6px;
    padding: 0 5px;
    border: 2px solid #ffffff;
    box-shadow: 0 2px 4px rgba(16, 185, 129, 0.3);

    ${media.mobile} {
        min-width: 16px;
        height: 16px;
        font-size: 9px;
        padding: 0 4px;
    }
`;

export const TestModeBadge = styled.div<{ $urgency?: 'normal' | 'warning' | 'critical' }>`
    display: flex;
    align-items: center;
    gap: 6px;
    padding: 4px 10px;
    border-radius: 6px;
    background: ${({ $urgency }) => {
    if ($urgency === 'critical') return 'rgba(239, 68, 68, 0.1)';
    if ($urgency === 'warning') return 'rgba(234, 148, 54, 0.1)';
    return 'rgba(107, 114, 128, 0.1)';
  }};
    border: 1px solid ${({ $urgency }) => {
    if ($urgency === 'critical') return 'rgba(239, 68, 68, 0.3)';
    if ($urgency === 'warning') return 'rgba(234, 148, 54, 0.3)';
    return 'rgba(107, 114, 128, 0.2)';
  }};
    white-space: nowrap;
    cursor: pointer;
    width: auto !important;
    height: auto !important;

    &:hover {
        background: ${({ $urgency }) => {
    if ($urgency === 'critical') return 'rgba(239, 68, 68, 0.15) !important';
    if ($urgency === 'warning') return 'rgba(234, 148, 54, 0.15) !important';
    return 'rgba(107, 114, 128, 0.15) !important';
  }};
        transform: none !important;
    }
`;

export const TestModeLabel = styled.span<{ $urgency?: 'normal' | 'warning' | 'critical' }>`
    font-size: 11px;
    font-weight: 500;
    color: ${({ $urgency }) => {
    if ($urgency === 'critical') return '#dc2626';
    if ($urgency === 'warning') return '#ea9436';
    return '#6b7280';
  }};
    line-height: 1.2;

    ${media.mobile} {
        font-size: 10px;
    }
`;

export const TestModeCountdown = styled.span<{ $urgency?: 'normal' | 'warning' | 'critical' }>`
    font-size: 11px;
    font-weight: 400;
    color: ${({ $urgency }) => {
    if ($urgency === 'critical') return '#b91c1c';
    if ($urgency === 'warning') return '#d97706';
    return '#374151';
  }};
    line-height: 1.2;

    ${media.mobile} {
        font-size: 10px;
    }
`;

/* Wrappery ikon w prawym TopBar — okrągłe 28×28 z szarym tłem i lekką ramką.
   Wzór 1:1 z `IconCircleButton` (Bell) i `UserMenu.AvatarWrapper` (avatar),
   żeby cała prawa nawigacja wyglądała spójnie. */
const iconCircleBase = `
    position: relative;
    width: 28px;
    height: 28px;
    display: inline-flex;
    align-items: center;
    justify-content: center;
    border-radius: 100%;
    cursor: pointer;
    transition: all 0.2s ease;
    box-sizing: border-box;
    flex-shrink: 0;
`;

export const DisabledMobileIcon = styled.div`
    ${iconCircleBase}
    background: ${({ theme }) => (theme.mode === 'dark' ? '#1f2937' : '#f3f4f6')};
    border: 1.5px solid ${({ theme }) => (theme.mode === 'dark' ? '#374151' : '#d1d5db')};
    color: ${({ theme }) => (theme.mode === 'dark' ? '#f3f4f6' : '#111827')};

    &::after {
        content: '';
        position: absolute;
        top: 50%;
        left: 50%;
        width: 18px;
        height: 1.5px;
        background: #6b7280;
        transform: translate(-50%, -50%) rotate(-45deg);
        pointer-events: none;
    }

    &:hover {
        background: ${({ theme }) => (theme.mode === 'dark' ? '#374151' : '#e5e7eb')};
        border-color: ${({ theme }) => (theme.mode === 'dark' ? '#4b5563' : '#9ca3af')};
    }

    ${media.tablet} {
        width: 26px;
        height: 26px;
    }

    ${media.mobile} {
        width: 24px;
        height: 24px;
    }
`;

export const MobileAppIcon = styled.div`
    ${iconCircleBase}
    background: ${({ theme }) => (theme.mode === 'dark' ? '#1f2937' : '#f3f4f6')};
    border: 1.5px solid ${({ theme }) => (theme.mode === 'dark' ? '#374151' : '#d1d5db')};
    color: ${({ theme }) => (theme.mode === 'dark' ? '#f3f4f6' : '#111827')};

    &:hover {
        background: ${({ theme }) => (theme.mode === 'dark' ? '#374151' : '#e5e7eb')};
        border-color: ${({ theme }) => (theme.mode === 'dark' ? '#4b5563' : '#9ca3af')};
    }

    ${media.tablet} {
        width: 26px;
        height: 26px;
    }

    ${media.mobile} {
        width: 24px;
        height: 24px;
    }
`;

export const MobileAppStatusBadge = styled.span<{ $active: boolean }>`
    position: absolute;
    top: 6px;
    right: 6px;
    width: 10px;
    height: 10px;
    border-radius: 50%;
    background: ${({ $active }) => ($active ? '#10b981' : '#ef4444')};
    border: 2px solid #ffffff;
    box-shadow: 0 0 0 2px ${({ $active }) => ($active ? 'rgba(16, 185, 129, 0.2)' : 'rgba(239, 68, 68, 0.2)')};

    ${media.mobile} {
        width: 8px;
        height: 8px;
        border: 1.5px solid #ffffff;
    }
`;

export const Active = styled.div`
    display: flex;
    align-items: center;
    gap: 8px;
    font-weight: 300;
    font-size: 14px;
    text-transform: uppercase;
    color: #374151;
    letter-spacing: 0.5px;

    ${media.mobile} {
        font-size: 12px;
        gap: 6px;
    }
`;

export const ActiveDot = styled.div`
    width: 8px;
    height: 8px;
    border-radius: 50%;
    background: #10b981;
    box-shadow: 0 0 0 3px rgba(16, 185, 129, 0.2);
    animation: pulse 2s ease-in-out infinite;
    flex-shrink: 0;

    ${media.mobile} {
        width: 6px;
        height: 6px;
    }

    @keyframes pulse {
        0%, 100% {
            box-shadow: 0 0 0 3px rgba(16, 185, 129, 0.2);
        }
        50% {
            box-shadow: 0 0 0 6px rgba(16, 185, 129, 0.1);
        }
    }
`;
